import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsightsContainer, ApplicationInsightsServiceInterface } from './ApplicationInsightsServiceInterface';

let reactPlugin: ReactPlugin | null = null;
const applicationInsightsContainer = {} as ApplicationInsightsContainer;
let appInsightsConnection: string | undefined = undefined;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, applicationInsights: Object, initialize: Function}} - Object
 */
const createApplicationInsightsService = () => {
  /**
   * Set connectionString
   * @param {string} connectionString - Application Insights Connection String
   */
  const setConnectionString = (connectionString: string) => (appInsightsConnection = connectionString);

  /**
   * Initialize the Application Insights class
   * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
   * @return {void}
   */
  const initialize = (browserHistory: any) => {
    if (!appInsightsConnection) {
      throw new Error('ConnectionString connectionString is required. Call setConnectionString first.');
    }
    if (!browserHistory) {
      throw new Error('Could not initialize Telemetry Service');
    }

    reactPlugin = new ReactPlugin();

    applicationInsightsContainer.applicationInsights = new ApplicationInsights({
      config: {
        connectionString: appInsightsConnection,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });

    applicationInsightsContainer.applicationInsights.loadAppInsights();
  };

  return {
    reactPlugin,
    applicationInsightsContainer,
    initialize,
    setConnectionString,
  };
};

export const ApplicationInsightsService = createApplicationInsightsService() as ApplicationInsightsServiceInterface;
